<div class="message-token">
  <p>Now you can <strong>COPY</strong> your new personal Access Token by clicking the the link. This is the only time you have access to copy it, <strong>SAVE</strong> it and keep it secure.</p>
  <p>If you lost or forgot this token, you must regenerate a new one.</p>
</div>
<div class="action-feedback message-copied" [hidden]="!copied" >Token copied to clipboard!</div>
<ul>
    <core-helpers-lists-one-action-list-item
        [title]="accessToken.name"
        [subtitle]="accessToken.read_only ? '(Read only)' : ''"
        [actionText]="'Copy'"
        (actionClick)="copyToClipboard(accessToken)"
        [type]="'disabled'"
    ></core-helpers-lists-one-action-list-item>
</ul>
<div class="box_fieldset">
  <core-helpers-forms-button-white [text]="'Done'" (click)= "onDone($event)"></core-helpers-forms-button-white>
</div>
